import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-714f32e8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dialog-header" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", { class: "el-icon el-icon-search fas" }, null, -1))
const _hoisted_3 = { class: "dialog-content" }
const _hoisted_4 = {
  key: 0,
  class: "date-picker-container"
}
const _hoisted_5 = {
  key: 0,
  class: "hasdata"
}
const _hoisted_6 = {
  key: 0,
  class: "hasdata"
}
const _hoisted_7 = /*#__PURE__*/_createTextVNode("OK")
const _hoisted_8 = ["infinite-scroll-disabled"]
const _hoisted_9 = {
  key: 0,
  class: "more-btn-wrapper"
}
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Cargar más ")
const _hoisted_11 = { class: "dialog-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_station_image_component = _resolveComponent("station-image-component")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_infinite_scroll = _resolveDirective("infinite-scroll")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    "model-value": true,
    width: "580px",
    "destroy-on-close": "",
    title: _ctx.title
  }, {
    footer: _withCtx(() => [
      _createElementVNode("span", _hoisted_11, [
        _createVNode(_component_el_button, {
          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.close()))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("btn.close")), 1)
          ]),
          _: 1
        })
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_el_button, {
          class: "btn",
          type: "primary",
          size: "default",
          circle: "",
          onClick: _ctx.onToggleDatePicker,
          title: "Filtrar por fechas"
        }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        (_ctx.showDatePickers)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(_component_el_col, { span: 24 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form, { "label-width": "80px" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_row, { gutter: 20 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_col, { span: 12 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_form_item, { label: "Desde" }, {
                                default: _withCtx(() => [
                                  (_openBlock(), _createBlock(_component_el_date_picker, {
                                    modelValue: _ctx.fromDate,
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.fromDate) = $event)),
                                    type: "datetime",
                                    placeholder: "DD/MM/AAAA hh:mm",
                                    class: "custom-date-picker full-width",
                                    key: _ctx.dateKey,
                                    format: "YYYY-MM-DD HH:mm"
                                  }, {
                                    default: _withCtx((cell) => [
                                      _createElementVNode("div", {
                                        class: _normalizeClass(["cell", { current: cell.isCurrent }])
                                      }, [
                                        _createElementVNode("span", {
                                          class: _normalizeClass({ text: true, nodata: !_ctx.hasEstimatedData(cell.date) })
                                        }, _toDisplayString(cell.text), 3),
                                        (_ctx.hasEstimatedData(cell.date))
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_5))
                                          : _createCommentVNode("", true)
                                      ], 2)
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue"]))
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_col, { span: 12 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_form_item, { label: "Hasta" }, {
                                default: _withCtx(() => [
                                  (_openBlock(), _createBlock(_component_el_date_picker, {
                                    modelValue: _ctx.toDate,
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.toDate) = $event)),
                                    type: "datetime",
                                    placeholder: "DD/MM/AAAA hh:mm",
                                    class: "custom-date-picker full-width",
                                    key: _ctx.dateKey,
                                    format: "YYYY-MM-DD HH:mm"
                                  }, {
                                    default: _withCtx((cell) => [
                                      _createElementVNode("div", {
                                        class: _normalizeClass(["cell", { current: cell.isCurrent }])
                                      }, [
                                        _createElementVNode("span", {
                                          class: _normalizeClass({ text: true, nodata: !_ctx.hasEstimatedData(cell.date) })
                                        }, _toDisplayString(cell.text), 3),
                                        (_ctx.hasEstimatedData(cell.date))
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_6))
                                          : _createCommentVNode("", true)
                                      ], 2)
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue"]))
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_row, { gutter: 20 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_col, { span: 12 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_form_item, { label: "Cámara" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_select, {
                                    modelValue: _ctx.cameraSelect,
                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.cameraSelect) = $event)),
                                    placeholder: "Selecciona una opción",
                                    class: "full-width"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_option, {
                                        label: "Todas",
                                        value: undefined
                                      }),
                                      _createVNode(_component_el_option, {
                                        label: "RGB",
                                        value: "RGB"
                                      }),
                                      _createVNode(_component_el_option, {
                                        label: "RGB-F",
                                        value: "RGB-F"
                                      }),
                                      _createVNode(_component_el_option, {
                                        label: "RGB-SF",
                                        value: "RGB-SF"
                                      }),
                                      _createVNode(_component_el_option, {
                                        label: "IN",
                                        value: "IN"
                                      }),
                                      _createVNode(_component_el_option, {
                                        label: "UV",
                                        value: "UV"
                                      })
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_col, { span: 12 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_form_item, { label: "Tipo" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_select, {
                                    modelValue: _ctx.type,
                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.type) = $event)),
                                    class: "full-width"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_option, {
                                        label: "Todos",
                                        value: undefined
                                      }),
                                      _createVNode(_component_el_option, {
                                        label: "CORRECT",
                                        value: "CORRECT"
                                      }),
                                      _createVNode(_component_el_option, {
                                        label: "ANOMALY",
                                        value: "ANOMALY"
                                      }),
                                      _createVNode(_component_el_option, {
                                        label: "BLACK",
                                        value: "BLACK"
                                      }),
                                      _createVNode(_component_el_option, {
                                        label: "WHITE",
                                        value: "WHITE"
                                      }),
                                      _createVNode(_component_el_option, {
                                        label: "INVALID",
                                        value: "INVALID"
                                      })
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_row, { gutter: 20 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_col, { span: 24 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_form_item, {
                                label: "Origen de Imágenes",
                                "label-width": "auto"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_select, {
                                    modelValue: _ctx.originFilter,
                                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.originFilter) = $event))
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_option, {
                                        label: "Todas",
                                        value: "ALL"
                                      }),
                                      _createVNode(_component_el_option, {
                                        label: "Estación",
                                        value: "STATION"
                                      }),
                                      _createVNode(_component_el_option, {
                                        label: "Captura Masiva",
                                        value: "MASSIVE"
                                      })
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_col, {
                            span: 24,
                            class: "text-right"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_button, {
                                type: "primary",
                                onClick: _ctx.searchImages
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_7
                                ]),
                                _: 1
                              }, 8, ["onClick"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true)
      ]),
      _withDirectives((_openBlock(), _createElementBlock("div", {
        class: "list-images",
        "infinite-scroll-disabled": _ctx.loadingMore,
        "infinite-scroll-distance": 10
      }, [
        _createVNode(_component_station_image_component, {
          images: _ctx.images,
          modal: true
        }, null, 8, ["images"]),
        (_ctx.hasMore)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createVNode(_component_el_button, {
                type: "primary",
                loading: _ctx.loadingMore,
                disabled: _ctx.loadingMore || !_ctx.hasMore,
                onClick: _ctx.loadMore
              }, {
                default: _withCtx(() => [
                  _hoisted_10
                ]),
                _: 1
              }, 8, ["loading", "disabled", "onClick"])
            ]))
          : _createCommentVNode("", true)
      ], 8, _hoisted_8)), [
        [_directive_infinite_scroll, _ctx.loadMore]
      ])
    ]),
    _: 1
  }, 8, ["title"]))
}